import ClickSpark from "utils/ClickSpark";
import LineBackground from "components/common/LineBackground"

import config from "config/config.dev"
import Navbar from "components/common/Navbar";
import Footer from "components/common/Footer";

const MainLayout = ({ children }) => {
    const featureLineBackground = config.features.lineBackground || false;  // Splash Cursor Enable/Disable Switch
    return (
        <div className="overflow-hidden">
            <ClickSpark
                sparkColor="#E91E63"
                sparkSize={13}
                sparkRadius={25}
                sparkCount={8}
                duration={500}
            >
                <div className="w-full min-h-[100vh]">
                    {/* Remove the following line to disable LineBackground permanently */}
                    {featureLineBackground ? <LineBackground /> : null}

                    <Navbar />

                    {/* This is importing the children in the main Landing file. */}
                    {children}

                    <Footer />

                </div>
            </ClickSpark >
        </div>
    );
};

export default MainLayout;